import AdDetails from './ad-details'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    AdDetails.state
  ),
  mutations: Object.assign(
    AdDetails.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/ads/index.js